import { useTranslation } from 'react-i18next'

export default function ContactHero() {
  const { t } = useTranslation()

  return (
    <section className="px-5 sm:px-8 md:px-10 lg:px-12 max-w-[1440px] mx-auto mb-8 md:mb-12 pt-18 md:pt-20">
      <div className="flex flex-col md:flex-row gap-8 md:gap-16 lg:gap-20">
        <div className="w-full md:w-3/4">
          <span className="text-primary font-body text-xs uppercase tracking-[0.3em] mb-8 block">
            {t('contact.hero.subtitle')}
          </span>
          <h1 className="font-display text-3xl sm:text-5xl md:text-6xl lg:text-8xl font-extrabold tracking-tighter leading-[0.9] text-on-surface uppercase">
            {t('contact.hero.headingLine1')} <br />
            <span className="text-transparent bg-clip-text bg-linear-to-r from-primary to-primary-container">
              {t('contact.hero.headingHighlight')}
            </span>
          </h1>
        </div>
        <div className="w-full md:w-1/4 flex flex-col justify-end pb-4">
          <p className="text-on-surface-variant text-sm leading-relaxed font-light">
            {t('contact.hero.description')}
          </p>
        </div>
      </div>
    </section>
  )
}
